/**
 * RUM phase 1: initial-load milestones on the `performance.timeOrigin` clock,
 * one beacon per page load to `POST /v1/rum`, sampled (see sampling.ts).
 * `installRum(router)` once from `main.tsx`; `recordRumMilestone(...)`
 * wherever a milestone happens. Runs alongside the legacy
 * `PerformanceProvider` until validated.
 * Design: `docs/proposals/real-user-monitoring.md`.
 */
import { createRumSession } from './session';
import type { RumRouter } from './session';
import { sendRumBeacon } from './beacon';
import { getRumContext } from './context';
import { shouldSampleRumSession } from './sampling';

const session = createRumSession({ send: sendRumBeacon, getContext: getRumContext });

export function installRum(router: RumRouter): void {
  // Unsampled loads never install: no timers, no listeners, no beacon.
  // Milestones still record into the session harmlessly.
  if (!shouldSampleRumSession()) {
    return;
  }
  session.install(router);
}

export const recordRumMilestone = session.recordMilestone;
export { RumMilestone } from './types';
export type { RumInitialLoadPayload, RumSentReason } from './types';
